<template>
    <div >

        <tq-on-top-container p_class_s="TQ_margin_top_-52px ">

            <!-- 1) notification button -->
            <tq-notification-container
                slot="topLeft"
                v-if="!p_chatScrollToBottom_b"
                :style="{'zIndex': gv_zIndex.tqChat_notification}"
                class="TQ_bg_white TQ_btn TQ_bg_circle TQ_bg_white TQ_inline TQ_width_20px TQ_height_20px TQ_align_end TQ_margin_8px lc_scrollBtn TQ_box_shadow2"
                :num="p_bottomNotification_n"
                p_top="-10px"
                p_right="-8px"
                :show="p_bottomNotification_n > 0">
                <img :src="ass_img_arrowheads_down"
                     @click="pe_scrollDown_f"
                     class="TQ_fullScreen" />
            </tq-notification-container>

            <!-- 2) buttons -->
            <div slot="body" class="lc_bottom TQ_grid_col_Auto1frAuto TQ_grid_gap_4px TQ_padding_4px TQ_bg_gray4">

                <div class="">
                    <tq-dropdown :show-caret-down="false"
                                 class="lc_emoticons"
                                 :only-laptop-mode="true"
                                 :options-selectable="false"
                                 :p_only-upward_b="true"
                                 :options-width="p_bigMode_b ? '350px' : '270px'">

                        <img slot='select' class="select" :src="ass_img_smiley_b"/>

                        <div slot="options"
                             class="lc_option TQ_font_emoji TQ_margin_4px"
                             :class="p_bigMode_b ? 'TQ_text_24px' : 'TQ_text_24px'"

                             @click="m_userEvents_addEmoticon_f(emoticon)"
                             v-for="emoticon in ass_emoji" >
                            {{emoticon}}
                        </div>
                    </tq-dropdown>

                    <tq-image v-if="p_savedMessages_byTimestamp_c"
                         :pb_src_r="ass_img_envelope"
                         class="TQ_width_24px TQ_margin_4px TQ_clickable"
                              @click.native="savedMessageData_o.showPopUp_vb.val = true"/>

                </div>

                <tq-textarea-autosize :key="sendMsg_textarea_refreshKey_n"
                                      class="TQ_font_emoji TQ_padding_6px TQ_grid_verticalCenter"
                                      :class="p_bigMode_b ? 'TQ_text_20px' : 'TQ_text_16px'"
                                      :rows="p_bigMode_b ? 2 : 1"

                                      @keyup.ctrl.enter="m_userEvents_sendMessage_f"
                                      :p_placeholder_s="ass_strings.oneWord_message[p_systemLangCode_e] + '...'"
                                      :p_text_s="sendMsg_text_s"
                                      :pe_input_f="(newText_s) => {sendMsg_text_s = newText_s}"/>

                <tq-image @click.native="m_userEvents_sendMessage_f"
                     :class="{'TQ_rotate180d' : helper_getDirectionByLangCode(p_systemLangCode_e) === enum_directions.rtl}"
                     class="send TQ_grid_verticalCenter TQ_clickable" :pb_src_r="ass_img_send"/>
            </div>

        </tq-on-top-container>

        <!-- 3) saved messages -->
        <tq-popup v-if="p_savedMessages_byTimestamp_c" :show="savedMessageData_o.showPopUp_vb" :show-close-btn="true" max-width="500px" class="TQ_center">

            <div class="TQ_text_28px TQ_textColor_purple TQ_text_bold">
                {{ass_strings.twoWords_savedMessages[p_systemLangCode_e]}}
            </div>
            <hr>

            <!-- message list -->
            <div class="TQ_textAlign_initial TQ_scrollable TQ_maxHeight_60vh">

                <!-- saved message list -->
                <div class="TQ_grid_gap_8px TQ_margin_4px TQ_padding_8px TQ_bg_gray4 TQ_borderBox"
                     :class="savedMessageData_o.selectedSavedMsgIndex_n === index_n ? 'TQ_border_2px' :'TQ_bg_gray4 TQ_clickable'"

                     v-for="(savedMessage_c,index_n) in p_savedMessages_byTimestamp_c"
                     @click="m_savedMsg_clickSavedMessage_f(index_n)">

                    <!-- msg title -->
                    <div class="TQ_text_bold TQ_margin_bottom_2px">{{savedMessage_c.sm_title_s}}: </div>

                    <!-- msg text -->
                    <div>
                        <tq-textarea-autosize class="TQ_font_emoji lc_newMsgText TQ_padding_8px TQ_text_16px"
                                              v-if="savedMessageData_o.selectedSavedMsgIndex_n === index_n"
                                              :p_text_s="savedMessage_c.sm_text_s"
                                              :pe_input_f="(newText_s) => { savedMessage_c.sm_text_s = newText_s}"/>

                        <div v-else class="lc_text TQ_bg_white TQ_padding_8px TQ_borderRadius TQ_text_16px ">{{savedMessage_c.sm_text_s}}</div>

                    </div>

                    <!-- btns -->
                    <div v-if="savedMessageData_o.selectedSavedMsgIndex_n === index_n" class="TQ_grid_col_Auto1frAuto TQ_margin_top_8px">

                        <!-- send message -->
                        <div class="TQ_grid_verticalCenter">

                            <tq-btn-approve
                                class="TQ_bg_green TQ_padding_8px TQ_inline TQ_borderRadius TQ_clickable"
                                :approve-cb="m_userEvents_sendSavedMessage_f"
                                :popup-text="ass_strings.question_sendSavedMassage"
                                :system-lang-code="p_systemLangCode_e">
                                {{ass_strings.threeWords_sendToTeam[p_systemLangCode_e]}}
                            </tq-btn-approve>

                            <div class="TQ_padding_2px TQ_inline"></div>

                            <tq-btn-approve
                                class="TQ_bg_purple TQ_padding_8px TQ_inline TQ_borderRadius TQ_clickable"
                                :approve-cb="m_userEvents_sendSavedMessage_toAll_f"
                                :popup-text="ass_strings.question_sendSavedMassageToAll"
                                :system-lang-code="p_systemLangCode_e">
                                {{ass_strings.threeWords_sendToAll[p_systemLangCode_e]}}
                            </tq-btn-approve>

                        </div>

                        <!-- space -->
                        <div class="TQ_grid_verticalCenter"></div>

                        <!-- update and delete -->
                        <div class="TQ_grid_verticalCenter TQ_margin_top_4px">

                            <!-- update saved message-->
                            <tq-btn-approve
                                v-if="savedMessage_c.sm_text_s !== savedMessageData_o.oldSavedMessagesText_byTimestamp_c[savedMessage_c.sm_timestamp_t]"
                                class="TQ_inline"
                                :approve-cb="() => {m_savedMsg_update_f(savedMessage_c)}"
                                :popup-text="ass_strings.question_updateSavedMassage"
                                :system-lang-code="p_systemLangCode_e">

                                <img :src="ass_img_save_w" class="TQ_width_20px TQ_bg_blue TQ_padding_8px TQ_borderRadius TQ_clickable"/>
                            </tq-btn-approve>

                            <div class="TQ_padding_2px TQ_inline"></div>

                            <!-- delete saved message-->
                            <tq-btn-approve
                                class="TQ_inline"
                                :approve-cb="m_savedMsg_delete_f"
                                :popup-text="ass_strings.question_deleteSavedMassage"
                                :system-lang-code="p_systemLangCode_e">

                                <img :src="ass_img_garbage_w" class="TQ_width_20px TQ_bg_red TQ_padding_8px TQ_borderRadius TQ_clickable"/>
                            </tq-btn-approve>



                        </div>

                    </div>
                </div>

                <!-- no saved messages -->
                <div v-if="obj_size_fn(p_savedMessages_byTimestamp_c) === 0" class="TQ_center TQ_padding_8px TQ_text_20px">
                    {{ass_strings.sentence_thereAreNoSavedMessages[p_systemLangCode_e]}}.
                </div>

                <!-- new message -->
                <div class="TQ_padding_8px TQ_textAlign_initial TQ_margin_4px TQ_margin_top_8px TQ_clickable TQ_bg_gray4">

                    <!-- title -->
                    <div class="TQ_text_bold TQ_textColor_purple TQ_textAlign_initial TQ_text_24px">
                        {{ass_strings.twoWords_newMessage[p_systemLangCode_e]}}
                    </div>

                    <!-- new msg text -->
                    <div class="TQ_bg_gray3 TQ_padding_8px">

                        <input :placeholder="ass_strings.oneWord_title[p_systemLangCode_e]"
                               class="TQ_padding_4px TQ_margin_bottom_4px lc_newMsgTitle TQ_text_20px"
                               v-model="savedMessageData_o.title_s">

                        <tq-textarea-autosize class="TQ_font_emoji lc_newMsgText TQ_padding_4px TQ_text_16px"
                                              :key="savedMessageData_o.textareaKey_n "
                                              :p_placeholder_s="ass_strings.oneWord_message[p_systemLangCode_e] + '...'"
                                              :p_text_s="savedMessageData_o.text_s"
                                              :pe_input_f="(newText_s) => {savedMessageData_o.text_s = newText_s}"
                        />
                    </div>


                    <tq-btn-approve
                        v-if="savedMessageData_o.title_s !== '' && savedMessageData_o.text_s !== '' "
                        class="TQ_center"
                        :approve-cb="m_savedMsg_addNew_f"
                        :popup-text="ass_strings.question_addNewSavedMassage"
                        :system-lang-code="p_systemLangCode_e">

                        <div class="TQ_inline TQ_bg_blue TQ_padding_8px TQ_borderRadius TQ_clickable TQ_margin_top_8px TQ_text_24px">
                            {{ass_strings.twoWords_saveMessage[p_systemLangCode_e]}}
                        </div>
                    </tq-btn-approve>


                </div>

            </div>

        </tq-popup>

    </div>
</template>

<script>

    import {format_date_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import MyVideo from "../mediaComponenets/MyVideo";
    import TqTextareaAutosize from "../basic/TqTextareaAutosize";
    import TqDropdown from "../basic/TqDropdown";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {gv_emoji, gv_zIndex} from "../../scripts/S_GlobalVar";
    import {validator_objClass_fb, validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_langCodes
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {helper_getDirectionByLangCode_fe} from "../../scripts/S_Helper";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqNotificationContainer from "../basic/TqNotificationContainer";
    import {date_newDate_fd} from "../../scripts/S_Date";
    import {
        ass_img_add_w, ass_img_arrow_heads_down,
        ass_img_check_simple,
        ass_img_check_simple_two,
        ass_img_check_simple_two_purple,
        ass_img_edit2_w,
        ass_img_envelope,
        ass_img_garbage_w, ass_img_save_w,
        ass_img_send_p,
        ass_img_smiley_b
    } from "../../assets/scripts/Ass_Files";
    import {obj_size_fn} from "../../../functions/src/shareCode/Share_S_Obj";
    import {FB_Message, FB_SavedMessages, FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_chatMsgStatus, enum_directions} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqPopup from "../basic/TqPopup";
    import TqToggleDiv from "../basic/TqToggleDiv";
    import TqTable from "../basic2/TqTable";
    import {notification_notify} from "../../scripts/S_Notification";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import {gv_colorsDark} from "../../../functions/src/shareCode/Share_Ass_GlobalVirables";
    import TqImage from "@/components/basic/TqImage";

    export default {
        name: "TqChat_inputBar",
        components: {
            TqImage,
            TqBtnApprove,
            TqTable,
            TqToggleDiv,
            TqPopup,
            TqNotificationContainer,
            TqOnTopContainer,
            TqDropdown,
            TqTextareaAutosize,
            MyVideo
        },
        props: {


            p_systemLangCode_e:{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_currentUser_c:{
                type: FB_UserData,
                require:true
            },

            p_savedMessages_byTimestamp_c:{
                type: Object,
                validator(obj){
                    return validator_objClass_fb(obj, FB_SavedMessages)
                }
            },
            pe_setSavedMessage_f:{
                type: Function
            },

            p_chatScrollToBottom_b:{
                type: Boolean,
                require:true
            },
            p_bottomNotification_n:{
                type: Number,
                require:true
            },

            p_bigMode_b : {
                type: Boolean,
                default: false
            },

            // functions
            pe_sendMessageToAll_f:{
                type: Function,
                default: () => {}
            },
            pe_sendMessage_f:{
                type: Function,
                require:true
            },
            pe_scrollDown_f:{
                type: Function,
                require:true
            }

        },
        data(){
            return{
                sendMsg_text_s     :  "",
                sendMsg_textarea_refreshKey_n : 0,


                savedMessageData_o : {
                    showPopUp_vb            : {val : false},
                    title_s                 : "",
                    text_s                  : "",
                    selectedSavedMsgIndex_n : 0,
                    oldSavedMessagesText_byTimestamp_c : {},
                    textareaKey_n : 0,
                },

                // imports
                ass_colors                      : gv_colorsDark,
                ass_img_send                    : ass_img_send_p,
                ass_img_check_simple_two_purple : ass_img_check_simple_two_purple,
                ass_img_check_simple_two        : ass_img_check_simple_two,
                ass_img_check_simple            : ass_img_check_simple,
                ass_img_garbage_w               : ass_img_garbage_w,
                ass_img_edit2_w                 : ass_img_edit2_w,
                ass_img_save_w                  : ass_img_save_w,
                ass_img_add_w                   : ass_img_add_w,
                ass_img_envelope                : ass_img_envelope,
                ass_img_smiley_b                : ass_img_smiley_b,
                ass_img_arrowheads_down         : ass_img_arrow_heads_down,
                ass_emoji                       : gv_emoji,
                enum_chatMsgStatus              : enum_chatMsgStatus,
                enum_directions                 : enum_directions,
                ass_strings                     : ass_strings,
                gv_zIndex                       : gv_zIndex,
                helper_getDirectionByLangCode   : helper_getDirectionByLangCode_fe,
                formatDate                      : format_date_hh_mm_fs,
                obj_size_fn                     : obj_size_fn,

            }
        },
        methods:{

            // user events
            m_userEvents_addEmoticon_f(emoji){
                this.sendMsg_text_s += emoji
                this.sendMsg_textarea_refreshKey_n++
            },

            // send message
            m_userEvents_sendSavedMessage_f(){

                let msg_c = this.m_createMessage_fc(this.p_savedMessages_byTimestamp_c[this.savedMessageData_o.selectedSavedMsgIndex_n].sm_text_s)
                this.pe_sendMessage_f(msg_c)
                this.savedMessageData_o.showPopUp_vb.val = false

            },
            m_userEvents_sendSavedMessage_toAll_f(){

                let msg_c = this.m_createMessage_fc(this.p_savedMessages_byTimestamp_c[this.savedMessageData_o.selectedSavedMsgIndex_n].sm_text_s)
                this.pe_sendMessageToAll_f(msg_c)
                this.savedMessageData_o.showPopUp_vb.val = false

            },
            m_userEvents_sendMessage_f(){

                if(!this.sendMsg_text_s){
                    return
                }

                let msg_c = this.m_createMessage_fc(this.sendMsg_text_s)

                this.pe_sendMessage_f(msg_c, () => {})

                // this.m_scrollDown_f()
                this.sendMsg_text_s = ""
                this.sendMsg_textarea_refreshKey_n++


            },

            // saved messages
            m_savedMsg_clickSavedMessage_f(index_n){
                if(this.savedMessageData_o.selectedSavedMsgIndex_n !== index_n){
                    this.savedMessageData_o.selectedSavedMsgIndex_n = index_n

                    let savedMsg_c = this.p_savedMessages_byTimestamp_c[index_n]

                    if(this.savedMessageData_o.oldSavedMessagesText_byTimestamp_c[savedMsg_c.sm_timestamp_t] == null){
                        this.$set(this.savedMessageData_o.oldSavedMessagesText_byTimestamp_c,savedMsg_c.sm_timestamp_t,savedMsg_c.sm_text_s)
                    }
                }
            },
            m_savedMsg_delete_f(){

                this.pe_setSavedMessage_f(this.savedMessageData_o.selectedSavedMsgIndex_n, null, () => {})
                this.$delete(this.p_savedMessages_byTimestamp_c, this.savedMessageData_o.selectedSavedMsgIndex_n)

            },
            m_savedMsg_update_f(savedMsg_c){
                this.pe_setSavedMessage_f(savedMsg_c.sm_timestamp_t, savedMsg_c, () => {
                    notification_notify(ass_strings.oneWord_updated)
                })

                this.savedMessageData_o.oldSavedMessagesText_byTimestamp_c[savedMsg_c.sm_timestamp_t] = savedMsg_c.sm_text_s
            },
            m_savedMsg_addNew_f(){

                if(this.savedMessageData_o.title_s === "" || this.savedMessageData_o.text_s === ""){
                    notification_notify(ass_strings.oneWord_error, )
                    return
                }

                let timestamp_t = date_newDate_fd().getTime()

                this.p_savedMessages_byTimestamp_c[timestamp_t] = new FB_SavedMessages({
                    sm_title_s      : this.savedMessageData_o.title_s,
                    sm_text_s       : this.savedMessageData_o.text_s,
                    sm_timestamp_t  : timestamp_t,
                })

                this.pe_setSavedMessage_f(timestamp_t, this.p_savedMessages_byTimestamp_c[timestamp_t], () => {})


                this.savedMessageData_o.title_s = ""
                this.savedMessageData_o.text_s = ""
                this.savedMessageData_o.textareaKey_n ++
            },

            // helpers
            m_createMessage_fc(msgText_s){
                let now = date_newDate_fd();

                let userId_uid = this.p_currentUser_c ? this.p_currentUser_c.ud_userId_uid : ''

                return new FB_Message({
                    ms_sendTime_n               : now.getTime(),
                    ms_senderId_uid             : userId_uid,
                    ms_text_s                   : msgText_s,
                    ms_readMsg_byUserId_b       : {[userId_uid] : true},
                    ms_receiveMsg_byUserId_b    : {[userId_uid] : true},
                })

            },

        },
    }

</script>

<style scoped lang="scss">

    .lc_scrollBtn{
        //margin-top: -50px;
        //transform: translate(0, -50px);
    }

    .lc_bottom{

        .lc_emoticons{
            align-self: center;

            img.select{
                height: 24px;
                padding: 2px;
                border-radius: 50%;
                background: var(--color-purple_lite2);
                width: 24px;
                margin: 4px 2px 2px 2px;
                box-shadow: 0 6px 12px 1px rgba(0,0,0,0.2);
            }

            .lc_option{
                display: inline-block;
                padding: 4px;
            }

        }

        img.send{
            align-self: center;
            width: 24px;
        }

    }


    .lc_newMsgTitle{
        border: none;
        border-bottom: 1px solid gray;
    }

    .lc_newMsgText{
        border: none;
        border-bottom: 1px solid gray;
    }

    .lc_text {
        white-space: pre-line;
        word-break: break-word;
        &.emoji{
            font-size: 32px;
        }
    }



</style>
